module.exports = __webpack_public_path__ + "img/bell.d3c18b10.svg";